import Request from "@/services/request/index";

export const loginByUserPwd = (data) => {
  return Request.post({ url: "/member/auth/loginByUserPwd", data });
};

export const regByUserPwd = (data) => {
  return Request.post({ url: "/member/auth/regByUserPwd", data });
};

export const getInfo = () => {
  return Request.get({ url: "/member/user/get" });
}
// 通过账号、姓名和身份证号重置密码
export const resetPwdByUserPwd = (data) => {
  return Request.post({ url: "/member/auth/reset-password-by-identity", data });
}
